import { useMutation } from "@shared/lib/hooks";
import { FinanceApprovalService } from "../services/FinanceApprovalService";
import { ToastService } from "@shared/lib/services";
import {
  FINANCE_APPROVAL_QUERY_KEY,
  FINANCE_APPROVAL_QUERY_KEY_ID,
  GST_INVOICES_QUERY_KEY,
} from "../constants";
import {
  BRIEF_LIST_QUERY_KEY,
  BRIEF_LOT_FACETS_QUERY_KEY,
} from "@entities/brief/lib/constants";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import { IGstFileUploadRequest } from "@shared/lib/types/finance";
import { DOWNLOADS_LIST_QUERY_KEY } from "@entities/downloads/lib/constant";

export function useUploadGstFile() {
  const {
    mutate: uploadGstFile,
    isLoading: isUploading,
    isSuccess: isUploaded,
  } = useMutation({
    mutationFn: (data: IGstFileUploadRequest) =>
      FinanceApprovalService.uploadGstFile(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: { skipInvalidation: false },

    onSuccess: (c) => {
      setTimeout(() => {
        c.invalidateQueries({ queryKey: [...GST_INVOICES_QUERY_KEY] });
        c.invalidateQueries({ queryKey: DOWNLOADS_LIST_QUERY_KEY });
      }, 1000);
    },
  });

  return {
    uploadGstFile,
    isUploading,
    isUploaded,
  };
}
